import { IAlleleOverride } from "@nkr/models/hla";
import { FileDocumentType } from '@nkr/enums/index';

interface IProps {
    alleleOverride: IAlleleOverride,
    onGetFile: (docType: FileDocumentType, Id: number) => void
}

const AlleleUpdateRow = (props: IProps) => {
    const whichId = props.alleleOverride.donorAlleleId > 0 ? props.alleleOverride.donorAlleleId : props.alleleOverride.recipientAlleleId;
    const whichType = props.alleleOverride.donorAlleleId > 0 ? 'donor' : 'recipient';
    const docType = props.alleleOverride.donorAlleleId > 0 ? FileDocumentType.DonorHistoTyping : FileDocumentType.RecipientHistoTyping;

    return (
        <>
            <tr>
                <td>
                    {props.alleleOverride.id} - {props.alleleOverride.whichField}
                </td>
                <td>
                    <a href="#" onClick={(e) => { e.preventDefault(); props.onGetFile(docType, whichId); }}>Open PDF</a>
                </td>
            </tr>
        </>
    )
}

export default AlleleUpdateRow;